import termQueries from '@apis/queries/termQueries';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useCallback, useEffect, useMemo } from 'react';

import { termIdsAtom } from '../atoms/termAtoms';

function useTerms(termCategoryId: string) {
    const { data } = useQuery(termQueries.list(termCategoryId));
    const terms = data?.terms;
    const [termIds, setTermIds] = useAtom(termIdsAtom);
    const termId: string|undefined = termIds[termCategoryId];
    const setTermId = useCallback((id: string) => {
        setTermIds((prev) => ({ ...prev, [termCategoryId]: id }));
    }, [setTermIds, termCategoryId]);
    const { data: mainData } = useQuery(termQueries.main(termCategoryId));
    const currentTerm = useMemo(
        () => terms?.find((term) => term.id === termId),
        [termId, terms],
    );
    useEffect(() => {
        if (mainData) {
            setTermId(mainData.id);
        }
    }, [mainData, setTermId]);
    return {
        terms, currentTerm, termId, setTermId,
    };
}

export default useTerms;
